/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as McpRouteImport } from './routes/mcp'
import { Route as HistoryRouteImport } from './routes/history'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AuthCallbackRouteImport } from './routes/auth.callback'
import { Route as EndpointsTagOperationRouteImport } from './routes/endpoints.$tag.$operation'

const McpRoute = McpRouteImport.update({
  id: '/mcp',
  path: '/mcp',
  getParentRoute: () => rootRouteImport,
} as any)
const HistoryRoute = HistoryRouteImport.update({
  id: '/history',
  path: '/history',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthCallbackRoute = AuthCallbackRouteImport.update({
  id: '/auth/callback',
  path: '/auth/callback',
  getParentRoute: () => rootRouteImport,
} as any)
const EndpointsTagOperationRoute = EndpointsTagOperationRouteImport.update({
  id: '/endpoints/$tag/$operation',
  path: '/endpoints/$tag/$operation',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/history': typeof HistoryRoute
  '/mcp': typeof McpRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/endpoints/$tag/$operation': typeof EndpointsTagOperationRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/history': typeof HistoryRoute
  '/mcp': typeof McpRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/endpoints/$tag/$operation': typeof EndpointsTagOperationRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/history': typeof HistoryRoute
  '/mcp': typeof McpRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/endpoints/$tag/$operation': typeof EndpointsTagOperationRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/history'
    | '/mcp'
    | '/auth/callback'
    | '/endpoints/$tag/$operation'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/history'
    | '/mcp'
    | '/auth/callback'
    | '/endpoints/$tag/$operation'
  id:
    | '__root__'
    | '/'
    | '/history'
    | '/mcp'
    | '/auth/callback'
    | '/endpoints/$tag/$operation'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  HistoryRoute: typeof HistoryRoute
  McpRoute: typeof McpRoute
  AuthCallbackRoute: typeof AuthCallbackRoute
  EndpointsTagOperationRoute: typeof EndpointsTagOperationRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/mcp': {
      id: '/mcp'
      path: '/mcp'
      fullPath: '/mcp'
      preLoaderRoute: typeof McpRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/history': {
      id: '/history'
      path: '/history'
      fullPath: '/history'
      preLoaderRoute: typeof HistoryRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/callback': {
      id: '/auth/callback'
      path: '/auth/callback'
      fullPath: '/auth/callback'
      preLoaderRoute: typeof AuthCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/endpoints/$tag/$operation': {
      id: '/endpoints/$tag/$operation'
      path: '/endpoints/$tag/$operation'
      fullPath: '/endpoints/$tag/$operation'
      preLoaderRoute: typeof EndpointsTagOperationRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  HistoryRoute: HistoryRoute,
  McpRoute: McpRoute,
  AuthCallbackRoute: AuthCallbackRoute,
  EndpointsTagOperationRoute: EndpointsTagOperationRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
